import { JENTIS_USER } from 'utils';
import { isAdjustUrl } from './isAdjustUrl';

/**
 * Appends Jentis session ID and user ID as query params to an Adjust link, if not already present.
 */
export function addJentisSessionIdAndUserIdToAdjustLink(
  link: string,
  jentisSessionId: string | undefined,
  jentisUserId: string | undefined
) {
  let finalLink = link;

  if (isAdjustUrl(finalLink)) {
    if (jentisSessionId) {
      const param = `${JENTIS_USER.SessionId}=${jentisSessionId}`;

      if (!finalLink.includes(param)) {
        const separator = new URL(finalLink).search.length > 0 ? '&' : '?';

        finalLink += `${separator}${param}`;
      }
    }

    if (jentisUserId) {
      const param = `${JENTIS_USER.UserId}=${jentisUserId}`;

      if (!finalLink.includes(param)) {
        const separator = new URL(finalLink).search.length > 0 ? '&' : '?';

        finalLink += `${separator}${param}`;
      }
    }
  }

  return finalLink;
}
